import React from "react";

const RequestStatusLabel = ({ backgroundColor, title }) => (
  <div
    style={{ minHeight: "44px" }}
    className={`w-24 rounded flex p-1 items-center justify-center text-center text-white bg-${backgroundColor}`}
  >
    {title}
  </div>
);

export default RequestStatusLabel;
